import React from "react";
import styles from "../../Firms/Add/addfirm.module.css";
import { post } from "../../../../components/api";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { SweetAlert } from "../../../../helpers/helper";
import { useNavigate } from "react-router-dom";

const AddDriver = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("firstName is required"),
    lastName: Yup.string().required("lastName is required"),
    mobileNo: Yup.number().required("addressLine2 is required"),
  });

  const handleSubmit = async (values, resetForm) => {
    const response = await post("admin/tms/add/driver", {
      firstName: values.firstName,
      lastName: values.lastName,
      mobileNo: values.mobileNo,
    });
    if (response.status == 200) {
      SweetAlert("Driver Added Successfully", false);
      resetForm();
      navigate("/tms/driver");
    } else {
      SweetAlert(response?.message || "error adding driver", true);
    }
  };
  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}> Add Driver</p>
      </div>
      <div className={styles.ContentDiv}>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            mobileNo: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values, resetForm);
          }}
        >
          {(formik) => {
            const { resetForm } = formik;
            return (
              <Form>
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">First Name</label>
                    <input
                      className="form-control input-field"
                      id="firstName"
                      name="firstName"
                      placeholder="Enter First Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.firstName}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="field-error ">
                        {formik.errors.firstName}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Last Name</label>
                    <input
                      className="form-control input-field"
                      id="lastName"
                      name="lastName"
                      placeholder="Enter Last Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.lastName}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="field-error ">
                        {formik.errors.lastName}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Phone Number</label>
                    <input
                      className="form-control input-field"
                      id="mobileNo"
                      name="mobileNo"
                      placeholder="Enter Phone Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.mobileNo}
                    />
                    {formik.touched.mobileNo && formik.errors.mobileNo ? (
                      <div className="field-error ">
                        {formik.errors.mobileNo}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-12 col-lg-12 col-xs-12 mb-3">
                    <div className={styles.buttons}>
                      <button
                        type="button"
                        className={styles.CancelButton}
                        onClick={() => resetForm()}
                      >
                        Cancel
                      </button>
                      <button type="submit" className={styles.SubmitButton}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddDriver;
